import React, { useEffect, useState } from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { AuthService } from "../../../services/auth.service"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { organizationSelector } from "../../../store/selectors/organization.selector"
import type { IAuthCachedData } from "../../../types/data.types"
import { SingleOrganizationUserComponent } from "./singleOrganizationUser.component"

export const OrganizationUsersListComponent: React.FunctionComponent<{
    className?: string
}> = props => {
    const organizationState = useAppSelector(organizationSelector)

    const [authCachedData, setAuthCachedData] = useState<IAuthCachedData>()

    useEffect(() => {
        AuthService.getAuthCache().then(setAuthCachedData)
    }, [])

    return (
        <div
            className={`
                ${props.className}
            `}
        >
            {/*HEADINGS*/}
            <div
                className="
                    flex items-center px-[16px] py-[8px]
                    sticky top-0 bg-brand-warmLight05 z-10
                    md:hidden
                "
            >
                <PrimaryText
                    typography="h6"
                    className="opacity-75 w-[400px] mr-[16px]"
                >
                    Name
                </PrimaryText>

                <PrimaryText
                    typography="h6"
                    className="opacity-75 w-[150px] mr-[16px]"
                >
                    Role
                </PrimaryText>

                <PrimaryText typography="h6" className="opacity-75 flex-1">
                    Credits used this Month
                </PrimaryText>
            </div>

            {organizationState.users.map((user, index) => (
                <SingleOrganizationUserComponent
                    key={index}
                    user={user}
                    isLast={index === organizationState.users.length - 1}
                    currentUserAuthCachedData={authCachedData}
                />
            ))}
        </div>
    )
}
